import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  markedNotification: null,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setMarkedNotification: (state, action) => {
      state.markedNotification = action.payload;
    },
    clearMarkedNotification: (state) => {
      state.markedNotification = null;
    },
  },
});

export const { setMarkedNotification, clearMarkedNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
